import { CommonUtilityModule } from './../../shared/common-utility.module';
import { CharCountDirective } from './../../shared/directive/char-count.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LicenseLiabilityResolverService } from './license-liability-resolver.service';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddLicenseComponent } from './add-license/add-license.component';
import { AddLiabilityComponent } from './add-liability/add-liability.component';
import { LeftMenuModule } from 'src/app/shared/left-menu.module';
import { SharedTranslateLazyModule } from 'src/app/shared/shared-translate-lazy.module';
import { LicenseLiabilityRoutingModule } from './license-liability-routing.module';
import { DocumentViewModule } from 'src/app/document-view/document-view.module';
import { LiabilitiesComponent } from './liabilities/liabilities.component';
import { LicensesComponent } from './licenses/licenses.component';



@NgModule({
  declarations: [AddLicenseComponent, AddLiabilityComponent, HomeComponent, LiabilitiesComponent, LicensesComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    RouterModule,
    LeftMenuModule,
    LicenseLiabilityRoutingModule,
    SharedTranslateLazyModule,
    CommonUtilityModule
  
  ],
  exports:[],
  providers: [LicenseLiabilityResolverService]

})
export class LicenseLiabilityModule { }
